module.exports = __webpack_public_path__ + "img/steps.7b8d876f.png";